import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { Ref, useCallback } from "react";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import AttachFiles from "@coworker/apprestructured/src/task-management/components/AttachFiles/AttachFiles";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

const NO_NEW_OR_EXISTING_FILES: NewOrExistingFile[] = [];

export type AttachFilesCreatorFragmentConfigProps = EmptyObject;

type AttachFilesCreatorFragmentProps = {
  configProps: AttachFilesCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function AttachFilesCreatorFragment({
  commonProps,
}: AttachFilesCreatorFragmentProps) {
  const { blockInput, task, onTaskChange } = commonProps;
  const images = getByPath<NewOrExistingFile[]>(task, "files");
  const handleFilesChanged = useCallback(
    (files: NewOrExistingFile[]) => {
      onTaskChange({ files });
    },
    [onTaskChange]
  );

  return (
    <AttachFiles
      files={isLoading(images) ? NO_NEW_OR_EXISTING_FILES : images}
      onFilesChanged={handleFilesChanged}
      disabled={blockInput || isLoading(images)}
    />
  );
}

export default AttachFilesCreatorFragment;
